<template >
  <section >
    <!--产品列表-->
    <el-col :span="24" class="toolbar">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item  style="margin-bottom:5px">
          <el-col :span="12">
            <el-date-picker type="datetime"  placeholder="开始日期" v-model="formInline.startDate" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col :span="12">
            <el-date-picker type="datetime" placeholder="结束日期" v-model="formInline.endDate" style="width: 100%;"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item style="margin-bottom:5px">
          <el-input  v-model="formInline.keyWords" placeholder="关键字"></el-input>
        </el-form-item >
        <el-form-item style="margin-bottom:5px">
          <el-select v-model="formInline.posf" placeholder="推荐位置1" @change="getRecommendIndex2()" >
            <el-option
              v-for="item in formInline.position1Return"
              :label="item.value"
              :value="item.key"
              :key="item.key">
            </el-option>
          </el-select>
          <el-select v-model="formInline.posc" placeholder="推荐位置2" :span="8">
            <el-option
              v-for="item in formInline.position2Return"
              :label="item.value"
              :value="item.key"
              :key="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-select v-model="formInline.order" placeholder="排序" style="margin-bottom:10px">
          <el-option label="按添加时间排序" value=""></el-option>
          <el-option label="按权重排序" value="1"></el-option>
        </el-select >
        <el-form-item style="margin-bottom:10px">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="danger" icon="delete" v-if="buttonsAccessList.indexOf('批量删除') > -1" @click="handleDeleteBatdch" >批量删除</el-button>
          <el-button type="success" icon="plus"  v-if="buttonsAccessAdd.indexOf('新增') > -1" @click="handleAdd">新增推荐</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="24">
      <el-table :data="data" style="width:100%" v-loading="listLoading" @selection-change="handleSelectionChange" border >
        <el-table-column
          type="selection"
          width="50">
        </el-table-column>
        <!--<el-table-column prop="poArea" label="推荐位置" width="190" show-overflow-tooltip></el-table-column>-->
        <el-table-column prop="poArea" label="推荐位置" width="190" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-for="(item,index) in scope.row.poArea" :key="item" type="danger">{{index}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题	" width="350" show-overflow-tooltip></el-table-column>
        <el-table-column prop="weight" label="权重" width="75"></el-table-column>
        <el-table-column prop="url" label="链接" width="250" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorName" label="作者" width="80"></el-table-column>
        <el-table-column prop="createTime" label="添加时间" width="175"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" width="175"></el-table-column>
        <el-table-column
          fixed="right"
          :context="_self"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button
              size="small"
              v-if="buttonsAccessList.indexOf('操作-编辑') > -1"
              @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-if="buttonsAccessList.indexOf('操作-删除') > -1"
              @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="24" class="toolbar" style="padding-bottom:10px;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total" style="float:right">
      </el-pagination>
    </el-col>

    <!--编辑项目信息-->
    <el-dialog :title="editFormTtile" :visible.sync="editFormVisible" :close-on-click-modal="false" >
      <el-form :model="editForm" label-width="100px" :rules="editFormRules"  ref="editForm" >
        <el-form-item label="推荐位置" prop="posis">
          <el-select v-model="editForm.position1" placeholder="推荐位置1"  @change="getRecommendIndex3()" prop="position1">
            <el-option
              v-for="item in editForm.position1Return"
              :label="item.value"
              :value="item.key"
              :key="item.key">
            </el-option>
          </el-select>
          <el-select v-model="editForm.position2" placeholder="推荐位置2" prop="position1">
            <el-option
              v-for="item in editForm.position2Return"
              :label="item.value"
              :value="item.key"
              :key="item.key">
            </el-option>
          </el-select>
          <el-button type="primary" icon="plus" @click="addPosition"></el-button>
        </el-form-item>
        <el-form-item prop="positionArray">
          <el-tag
            v-for="tag in editForm.positionArray"
            @close="removePosition(tag)"
            :closable="true"
            type="primary"
            :key="tag.key">
            {{tag.value}}
          </el-tag>
        </el-form-item>
        <el-form-item label="图片标题" prop="title">
          <el-input v-model="editForm.title" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="图片链接" prop="url">
          <el-input v-model="editForm.url" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="imgUrl">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :before-upload="handleUpload"
            :on-success="handleSuccess"
            :file-list="editForm.fileList"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">图片支持jpg格式，大小300*400</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="图片权重" prop="weight">
          <el-input-number v-model.number="editForm.weight" style="width: 80%;" auto-complete="off"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editSubmit">立即创建</el-button>
          <el-button @click.native="editFormVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="codeTile" :visible.sync="codeVisible" :close-on-click-modal="false">
      <img :src="videoBuffer">
    </el-dialog>

  </section>
</template>
<style scoped>
  .toolbar {
    background: #fff;
    padding: 10px 10px 0px 10px;
  }
</style>
<script>
  import util from '../../common/js/util'
  import { getRecommendIndex1 , getRecommendIndex2 , getRecommendList , indexRecommend , updateRecommend , delRecommend} from '../../api/api';
  export default{
    data(){
      var validateImgUrl = (rule, value, callback) => {
        if(this.editForm.imgUrl==''){
          callback(new Error('请上传项目导图'));
        } else {
          callback();
        }
      };
      var validatePosition = (rule, value, callback) => {
        if(this.editForm.position==''){
          callback(new Error('请选择发布位置'));
        } else {
          callback();
        }
      };
      return {
        buttonsAccessList:this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[102101]?this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[102101].buttons:[],
        buttonsAccessAdd:this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[102100]?this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[102100].buttons:[],
        data: [],//table列表数据
        multipleSelection: [],//全选数组
        currentPage: 1,//当前页数
        pageSize: 10,//每页显示条目个数
        total: 0, //总条目数
        listLoading: false,
        editFormVisible: false,//编辑界面显是否显示
        editFormTtile: '编辑',//编辑界面标题
        videoBuffer:'',
        codeVisible:false,
        codeTile:'',
        editLoading: false,
        uploadUrl:process.env.VUE_APP_API_URL_WX+"/api/wechat/file/ImgFileUpload",
        formInline:{
          startDate:'',
          endDate:'',
          keyWords:'',
          oldPosf:'',
          posf:'',
          posc:'',
          position1Return:[],
          position2Return:[],
          order:'',
        },
        editForm: {
          id:'',
          position: '',
          oldPosition1: '',
          position1: '',
          position2: '',
          title: '',
          imgUrl:'',
          url: '',
          weight: '',
          positionArray: [],
          fileList:[],
          position1Return : [],
          position2Return : []
        },
        editFormRules: {
          positionArray: [
            {required: true,validator: validatePosition, trigger: 'change'},
          ],
          title: [
            {required: true, message: '请填图片标题', trigger: 'blur'},
          ],
          url: [
            {required: true, message: '请填图片链接', trigger: 'blur'},
          ],
          imgUrl: [
            {required: true,validator: validateImgUrl, trigger: 'change'}
          ],
          weight: [
            {required: true, type: 'number',message: '请填写权重', trigger: 'blur'},
            { type: 'number', message: '权重必须为数字值', trigger: 'blur'}
          ]
        },
      }
    },
    created () {
      this.initList();
      this.getRecommendIndex1();
    },
    methods: {
      initList(){//加载表格数据
        const formData = new FormData();
        formData.append('pageNum', this.currentPage);
        formData.append('pageSize', this.pageSize);
        if(this.formInline.startDate!='' && this.formInline.startDate){
          formData.append('startDate', util.formatDate.format(new Date(this.formInline.startDate), 'yyyy-MM-dd') );
        }
        if(this.formInline.endDate!='' && this.formInline.startDate){
          formData.append('endDate', util.formatDate.format(new Date(this.formInline.endDate), 'yyyy-MM-dd'));
        }
        formData.append('keyWords', this.formInline.keyWords);
        formData.append('posf', this.formInline.posf);
        formData.append('posc', this.formInline.posc);
        formData.append('order', this.formInline.order);
        this.listLoading = true;
        getRecommendList(formData).then((response) => {
          var data = response.data
          if (data.status == 200) {
            this.data = data.data.list;
            this.total = data.data.total;
          }
          this.listLoading = false;
        })
      },
      getRecommendIndex1(){
        const form = new FormData();
        getRecommendIndex1(form).then(response => {
          this.formInline.position1Return = response.data;
          this.editForm.position1Return = response.data;
        })
      },
      //搜索栏的推荐位置
      getRecommendIndex2(){
        const form = new FormData();
        form.append('position1', this.formInline.posf);
        getRecommendIndex2(form).then(response => {
          this.formInline.position2Return = response.data;
          if(this.formInline.position2Return.length>0){
              this.formInline.posc=this.formInline.position2Return[0].key
          }
        })
        if(this.formInline.oldPosf != this.formInline.posf ){
            this.formInline.posc='';
          this.formInline.oldPosf == this.formInline.posf;
        }
      },
      //新增编辑的推荐位置
      getRecommendIndex3(){
        const form = new FormData();
        form.append('position1', this.editForm.position1);
        getRecommendIndex2(form).then(response =>{
          this.editForm.position2Return = response.data;
        })
        if(this.editForm.oldPosition1 != this.editForm.position1 ){
            this.editForm.position2='';
          this.editForm.oldPosition1 == this.editForm.position1;
        }
      },
      onSubmit() {//查询
        this.initList()
      },
      handleSizeChange(val) {//修改页大小
        this.pageSize = val
        this.initList()
      },
      handleCurrentChange(val) {//修改当前页
        this.currentPage = val;
        this.initList()
      },
      handleSelectionChange(val) {//多选
        this.multipleSelection = val;
      },
      handleAdd(){//显示新增页
        this.editFormVisible = true;
        this.editFormTtile = '新增';
        this.editForm.id='',
        this.editForm.position= '',
        this.editForm.oldPosition1= '',
        this.editForm.position1= '',
        this.editForm.position2= '',
        this.editForm.title= '',
        this.editForm.imgUrl='',
        this.editForm.url= '',
        this.editForm.weight= '',
        this.editForm.positionArray= [],
        this.editForm.fileList=[]
      },
      handleEdit(index, row) {//显示编辑页
        this.editFormVisible = true;
        this.editFormTtile = '编辑';
        this.editForm.id=row.id;
        this.editForm.position= row.cId;
        this.editForm.oldPosition1= row.cId;
        this.editForm.title= row.title;
        this.editForm.imgUrl=row.imgUrl;
        this.editForm.url= row.url;
        this.editForm.weight= row.weight;
        this.editForm.positionArray= Object.assign([], row.positionArray);
        this.editForm.fileList=row.imgUrl?[{url: row.imgUrl}]:[]
      },
      removePosition(item){
        this.editForm.position=this.editForm.position.replace(item.key+";","");
        for(var i in this.editForm.positionArray){
          if(this.editForm.positionArray[i].key == item.key){
            this.editForm.positionArray.splice(i,1);
          }
        }
      },
      addPosition(){
        /*记录添加位置*/
        var posi=this.editForm.position;
        if(this.editForm.position1!=''){
          /*获取选中项1的文本----start*/
          var lable1="";
          for(var item in this.editForm.position1Return){
              if(this.editForm.position1Return[item].key == this.editForm.position1){
                lable1=this.editForm.position1Return[item].value;
              }
          }
          var map={}
          /*获取选中项1的文本----over*/
          if(this.editForm.position2!=''){
              /*获取选中项2的文本----start*/
              /* eslint-disable */
              var lable2="";
              for(var item in this.editForm.position2Return){
                if(this.editForm.position2Return[item].key == this.editForm.position2){
                  lable2=this.editForm.position2Return[item].value;
                }
              }
              /* eslint-enable */
              /*获取选中项2的文本----over*/
              if(posi.indexOf(this.editForm.position1+","+this.editForm.position2+";")<0){
                posi+=this.editForm.position1+","+this.editForm.position2+";"
                map={
                  key : this.editForm.position1+","+this.editForm.position2,
                  value: lable1+"---"+lable2
                }
                this.editForm.positionArray.push(map);
              }else{
                this.$message({
                  type: 'info',
                  message: '推荐位置选择重复'
                });
              }
          }else{
            if(posi.split(";").indexOf(this.editForm.position1+","+null)<0){
              posi+=this.editForm.position1+","+null+";"
              map={
                key : this.editForm.position1+","+null,
                value: lable1
              }
              this.editForm.positionArray.push(map);
            }else{
              this.$message({
                type: 'info',
                message: '推荐位置选择重复'
              });
            }
            /*构造页面显示选中项*/
          }
          this.editForm.position=posi;
        }else{
          this.$message({
            type: 'info',
            message: '请选择发布位置后再添加！'
          });
        }
      },
      handleUpload(file) {
        if (file.size > 200*1024) {
          this.$message.error('图标大小不能超过200kb, 请重新上传!')
          return false;
        }
      },
      handleSuccess(response){
        this.editForm.imgUrl=response.data.imgUrl
      },
      editSubmit() {//修改|新增产品
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            const formData = new FormData();
            formData.append('position', this.editForm.position);
            formData.append('title', this.editForm.title);
            formData.append('url', this.editForm.url);
            formData.append('weight', this.editForm.weight);
            formData.append('imgUrl', this.editForm.imgUrl);
            if (this.editForm.id == 0) {//新增
              indexRecommend(formData).then(response =>  {
                var data = response.data
                if (data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: data.msg
                  });
                    this.editFormVisible = false;
                    this.initList()
                } else {
                    this.$message({
                    type: 'warning',
                    message: data.msg
                  });
                }
              })
            } else {//修改
              formData.append('id', this.editForm.id);
              updateRecommend(formData).then(response => {
                var data = response.data
                if (data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: data.msg
                  });
                    this.editFormVisible = false;
                    this.initList()
                } else {
                    this.$message({
                    type: 'warning',
                    message: data.msg
                  });
                }
              })
            }
          }
        });
      },
      handleDelete(index, row) {//删除
        this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('ids', row.id);
          delRecommend(formData).then(response => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
                this.initList()
            } else {
                this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleDeleteBatdch() {//批量删除
        this.$confirm('此操作将永久删除选中项目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          var po="";
          for (var index in  this.multipleSelection){
            po+=this.multipleSelection[index].id+","
          }
          if(po.length>1){
            po=po. substring(0,po.length-1)
          }else{
            this.$message({
              type: 'warning',
              message: '请选择删除'
            });
            return false;
          }
          formData.append('ids', po);
          delRecommend(formData).then(response => {
            var data = response.data
            if (data.status == 200) {
                this.$message({
                type: 'success',
                message: data.msg
              });
                this.initList()
            } else {
                this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },




    }
  }
</script>

